import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEARCH_RESULTS_RESTORE_ALLOWED_KEY = 'airfly_results_restore_enabled';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip scroll-to-top if we're restoring search results from sessionStorage
    // (SearchFlights component will handle scroll restoration after results load)
    if (pathname === '/' || pathname === '/search-flights') {
      const canRestore = sessionStorage.getItem(SEARCH_RESULTS_RESTORE_ALLOWED_KEY);
      if (canRestore) {
        return; // Let SearchFlights handle scroll restoration
      }
    }
    
    // For all other routes, or fresh search page visits, scroll to top
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
